import React from "react";
import "./AboutUs.css";
// import sch from "../../images/abt.png";
import irfana from '../../images/Female/irfana.jpg'
import abuzar from '../../images/Male/abuzar.jpg'
import nadeem from '../../images/Male/nadeem.jpg'

const AboutUs = () => {
  return (
    <div className="aboutUs">
      <h1>
        <span>About Us</span>
      </h1>
      <h3>
        Welcome to Suffah High School, where we are committed to providing an
        exceptional educational experience for our students. Our team is
        dedicated to fostering an environment of academic excellence and
        personal growth. We are proud to introduce our esteemed staff who are
        instrumental in guiding our school towards success.
      </h3>

      <div className="aboutContent">
        <div>
          <img src={nadeem} alt="description" />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h3>
          <span style={{ color: "gold" }}>Nadeem Sir</span>, our esteemed Correspondence, plays a crucial role in
            maintaining effective communication and ensuring the smooth
            operation of our school. His dedication to the institution and his
            commitment to fostering a positive educational environment are truly
            commendable.
          </h3>
        </div>
      </div>

      <div className="aboutContent">
        <div>
          <img src={irfana} alt="description" />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h3>
          <span style={{ color: "gold" }}> Irfana Tanveer Ma'am</span>, our Vice Principal, brings a wealth of
            knowledge and experience to our leadership team. Her vision and
            leadership are pivotal in driving our educational programs and
            initiatives forward. She is deeply committed to the holistic
            development of our students, ensuring they receive a balanced and
            enriching education.
          </h3>
        </div>
      </div>

      <div className="aboutContent">
        <div>
          <img src={abuzar} alt="description" />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h3>
          <span style={{ color: "gold" }}>Abuzar Sir</span>, a valued member of our management team, brings a unique
            blend of strategic insight and operational expertise to Suffah High
            School. His innovative approach and unwavering dedication are key to
            our continuous growth and improvement. Abuzar's contributions are
            vital in shaping the school's policies and enhancing our educational
            framework, ensuring we remain at the forefront of academic
            excellence.
          </h3>
        </div>
      </div>

      <h3 style={{ marginTop: "40px" }}>
      <span style={{ color: "gold" }}>At Suffah High School, we strive to nurture the intellectual and
        personal development of each student, preparing them for future
        success. Our dedicated faculty and staff work tirelessly to create a
        supportive and challenging academic environment, where students are
        encouraged to reach their full potential.</span>
        <br /><br />
        Join us at Suffah High School, where excellence in education is our
        tradition, and student success is our mission.
      </h3>
    </div>
  );
};

export default AboutUs;
